/* JC recently viewed — saves each PDP's shared-card markup to localStorage and
   renders the visitor's previously-viewed products (newest-first, current excluded).
   Stays hidden when there is nothing to show. */
// Stored card HTML goes stale when the card markup changes; bump the key with each card
// markup change so visitors never get old cards (v1 held the old image-swatch cards, v2 the
// cards with a 2nd hover photo, v3 the cards with no circle for single-color products).
const VIO_RV_KEY = 'jc:recently-viewed:v4';
try {
  localStorage.removeItem('jc:recently-viewed');
  localStorage.removeItem('jc:recently-viewed:v2');
  localStorage.removeItem('jc:recently-viewed:v3');
} catch (e) {
  /* private mode — ignore */
}

class JcRecentlyViewed extends HTMLElement {
  connectedCallback() {
    const handle = this.dataset.handle;
    const max = parseInt(this.dataset.max || '4', 10);

    let store = [];
    try {
      store = JSON.parse(localStorage.getItem(VIO_RV_KEY) || '[]');
      if (!Array.isArray(store)) store = [];
    } catch (e) {
      store = [];
    }

    // Save the current product's card (freshest first).
    const tpl = this.querySelector('[data-rv-current]');
    const currentHtml = tpl ? tpl.innerHTML.trim() : '';
    if (handle && currentHtml) {
      store = store.filter((e) => e && e.handle !== handle);
      store.unshift({ handle: handle, html: currentHtml, ts: Date.now() });
      store = store.slice(0, 12);
      try {
        localStorage.setItem(VIO_RV_KEY, JSON.stringify(store));
      } catch (e) {
        /* quota / private mode — ignore */
      }
    }

    // Render everything else, newest-first: never more than one desktop row (4); CSS shows
    // 2 of them on mobile and 3 on tablet.
    const others = store.filter((e) => e && e.handle !== handle && e.html).slice(0, Math.min(max, 4));
    if (!others.length) return; // leave the section hidden

    const grid = this.querySelector('[data-rv-grid]');
    if (!grid) return;
    const frag = document.createDocumentFragment();
    others.forEach((e) => {
      const li = document.createElement('li');
      li.className = 'vio-rv__item';
      li.innerHTML = e.html;
      frag.appendChild(li);
    });
    grid.appendChild(frag);

    const wrap = this.closest('[data-rv-wrap]');
    if (wrap) wrap.hidden = false;
  }
}

if (!customElements.get('jc-recently-viewed')) {
  customElements.define('jc-recently-viewed', JcRecentlyViewed);
}
